/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Charts_Rest_TitleInputs */

const en_us2_ui_charts_rest_title = /** @type {(inputs: Ui_Charts_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest`)
};

const pt_br2_ui_charts_rest_title = /** @type {(inputs: Ui_Charts_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso`)
};

const es_419_ui_charts_rest_title = /** @type {(inputs: Ui_Charts_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso`)
};

const pt_pt2_ui_charts_rest_title = /** @type {(inputs: Ui_Charts_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso`)
};

const fr_fr2_ui_charts_rest_title = /** @type {(inputs: Ui_Charts_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repos`)
};

const de_de2_ui_charts_rest_title = /** @type {(inputs: Ui_Charts_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const it_it2_ui_charts_rest_title = /** @type {(inputs: Ui_Charts_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero`)
};

/**
* | output |
* | --- |
* | "Rest" |
*
* @param {Ui_Charts_Rest_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_rest_title = /** @type {((inputs?: Ui_Charts_Rest_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_Rest_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_rest_title(inputs)
	if (locale === "es-419") return es_419_ui_charts_rest_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_rest_title(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_rest_title(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_rest_title(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_rest_title(inputs)
	return en_us2_ui_charts_rest_title(inputs)
});
export { ui_charts_rest_title as "ui-charts.rest_title" }